import { Components, Theme } from '@mui/material';

// Create a direct copy of the base grid with any dark-theme specific styles
export const muiGrid: Theme['components'] = {
  MuiGrid: {
    defaultProps: {
      columns: 24, // Keep the 24-column grid configuration
    },
    styleOverrides: {
      root: {
        // Dark theme specific grid styling if needed
      },
      container: {
        // Dark theme specific container styling if needed
      },
      item: {
        // Dark theme specific item styling if needed
      },
    },
  } as Components['MuiGrid'],
};
